/**
 * Fetches Shopify product recommendations for the current product and swaps
 * the rendered section content in. Loads lazily when scrolled near viewport.
 */
window.WsRelatedProducts = class WsRelatedProducts extends HTMLElement {
  #observer = null;
  #loaded = false;

  connectedCallback() {
    if (!this.dataset.url) return;

    this.#observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.#load();
      },
      { rootMargin: '400px 0px' }
    );
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  async #load() {
    if (this.#loaded) return;
    this.#loaded = true;
    this.#observer?.disconnect();

    try {
      const response = await fetch(this.dataset.url);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const next = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('ws-related-products');

      if (next?.innerHTML.trim()) {
        this.innerHTML = next.innerHTML;
        // Related cards render after BayEngage's initial widget scan — re-run it
        // so the freshly injected `_tbr_col_stat` badges get their stars.
        window.initializeCollectionStatisticsWidgets?.();
      }
    } catch (error) {
      console.error('Related products failed to load:', error);
    }
  }
}

if (!customElements.get('ws-related-products')) {
  customElements.define('ws-related-products', WsRelatedProducts);
}
